import { render } from "./MainMenuItems.vue?vue&type=template&id=0bb1b572&scoped=true&ts=true"
import script from "./MainMenuItems.vue?vue&type=script&lang=ts"
export * from "./MainMenuItems.vue?vue&type=script&lang=ts"

import "./MainMenuItems.vue?vue&type=style&index=0&id=0bb1b572&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb1b572"]])

export default __exports__